import 'ui-library/components/Table/Table.css';
import React from 'react';

import { Pagination } from 'ui-library';
import { createUniqueKey } from 'utils';
import ActionButtons from './ActionsButtons/ActionsButtons';

import { TableRow } from './TableRow';

const CustomTable = ({
    columns,
    data,
    onChange,
    paging,
    actions = [],
}) => (
    <>
        {actions && <ActionButtons actions={actions}/>}
        <div className="Table-wrapper table-wrapper">
            <table className="Table table">
                <thead>
                    <tr>
                        {columns.map(({
                            key,
                            title,
                        }) => (
                            <th key={key}>{title}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((rowData, idx) => (
                        <TableRow
                            key={createUniqueKey(idx, '')}
                            rowData={rowData}
                            columns={columns}
                        />
                    ))}
                </tbody>
            </table>
            {paging.pageSize && (
                <Pagination
                    total={paging.totalPages}
                    currentPage={paging.pageNumber}
                    pageSize={paging.pageSize}
                    onChange={onChange}
                />
            )}
        </div>
    </>
);

export default CustomTable;
